// @ts-check
import { useState } from 'react';
import _ from 'lodash';
import { Flex, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { LINE_HEIGHT, SPACES } from 'common/constants/sizes';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { LBButton } from '@linearb/buzz';

const ConfirmModal = ({
  title,
  description,
  confirmText,
  cancelText,
  onCancel,
  onConfirm,
  confirmationModalOptions,
  buttonsContainerFlexDirection = 'row-reverse',
  CheckboxCheckedNote = null,
  descriptionTextWidth
}) => {
  const checkboxSettings = _.get(confirmationModalOptions, 'checkbox', null);
  const defaultCheckboxValue = _.get(
    checkboxSettings,
    'is_checked_by_default',
    false
  );
  const [isChecked, setIsChecked] = useState(defaultCheckboxValue);
  const [saving, setSaving] = useState(false);

  const checkBoxNoteStyle = {
    opacity: !isChecked ? 0 : 1,
    transition: 'all 0.2s ease-in'
  };
  return (
    <Padding padding='medium'>
      <Flex direction='column' justify='space-between'>
        <Flex width='100%'>
          {title ? <Text size='x-x-large'>{title}</Text> : null}
        </Flex>
        <Text
          size='large'
          lineHeight={LINE_HEIGHT.large}
          pb={checkboxSettings ? SPACES.small : SPACES.big}
          pt={SPACES.medium}
          width={descriptionTextWidth}
        >
          {description}
        </Text>
        {checkboxSettings ? (
          <Padding>
            <FormControlLabel
              label={
                <Text color='black' size='large' weight='300'>
                  {checkboxSettings.label}
                </Text>
              }
              control={
                <Checkbox
                  onChange={() => setIsChecked(!isChecked)}
                  checked={isChecked}
                  value={isChecked}
                  inputProps={{
                    'aria-label': 'primary checkbox'
                  }}
                  color='primary'
                />
              }
            />
            {CheckboxCheckedNote ? (
              <Flex style={checkBoxNoteStyle}>{CheckboxCheckedNote}</Flex>
            ) : null}
          </Padding>
        ) : null}
        <Flex direction={buttonsContainerFlexDirection} pt='2rem'>
          <Padding r={descriptionTextWidth ? 'small' : null}>
            <LBButton
              disabled={saving}
              onClick={async () => {
                if (checkboxSettings) {
                  const { key, checked_value, unchecked_value } =
                    checkboxSettings;
                  setSaving(true);
                  await onConfirm({
                    [key]: isChecked ? checked_value : unchecked_value
                  });
                  setSaving(false);
                } else {
                  setSaving(true);
                  await onConfirm();
                  setSaving(false);
                }
              }}
            >
              {confirmText}
            </LBButton>
          </Padding>
          <Padding r={!descriptionTextWidth ? 'small' : null}>
            <LBButton
              variant='outline'
              onClick={() => {
                onCancel();
              }}
            >
              {cancelText}
            </LBButton>
          </Padding>
        </Flex>
      </Flex>
    </Padding>
  );
};
export default ConfirmModal;
